import {
  getProGroupsListQueryKey,
  getProGroupsListQueryOptions,
  getProGroupsMembersListQueryKey,
  getProGroupsMergedMembersListQueryKey,
  type ProGroupListItem,
  type ProGroupsListParams,
} from "@sidegigllc/api/client";
import { useQuery, useQueryClient } from "@tanstack/react-query";

type EnabledOpts = { enabled?: boolean };

export type GroupedProGroups = {
  all: Array<ProGroupListItem>;
  user: Array<ProGroupListItem>;
  autogenerated: Array<ProGroupListItem>;
};

export const groupProGroups = (items: Array<ProGroupListItem>): GroupedProGroups => {
  const all = items.toSorted((a, b) => a.name.localeCompare(b.name));
  return all.reduce<GroupedProGroups>(
    (acc, group) => {
      (group.is_autogenerated ? acc.autogenerated : acc.user).push(group);
      return acc;
    },
    { all, user: [], autogenerated: [] },
  );
};

export const proGroupsQueryOptions = (params: ProGroupsListParams, options?: EnabledOpts) =>
  getProGroupsListQueryOptions(params, { query: { select: groupProGroups, ...options } });

export const useProGroups = (params: ProGroupsListParams, options?: EnabledOpts) =>
  useQuery(proGroupsQueryOptions(params, options));

export const useInvalidateProGroups = () => {
  const queryClient = useQueryClient();
  return (groupId?: number) =>
    Promise.all([
      queryClient.invalidateQueries({ queryKey: getProGroupsListQueryKey() }),
      queryClient.invalidateQueries({ queryKey: getProGroupsMergedMembersListQueryKey() }),
      groupId == null
        ? undefined
        : queryClient.invalidateQueries({ queryKey: getProGroupsMembersListQueryKey(groupId) }),
    ]);
};
